/* eslint-disable camelcase */
export const SET_ABTest = 'SET_ABTest';

export function setABTest(abTest) {
  return {
    type: SET_ABTest,
    payload: abTest,
  };
}
